import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, onMounted } from 'vue'
import { GD, Storage, STORE_NAME, User } from '@gd/storage'
import { GdFooter } from '@gd/classic-template'
import events from '@gd/event-bus'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  props: {
    footer: { type: Boolean, default: true },
    footerBlank: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const footerRef = ref(props.footer)
const footerBlankRef = ref(props.footerBlank)
const storeGd: GD = new Storage().read(STORE_NAME.GD)
const storeUser: User = new Storage().read(STORE_NAME.USER)
const payout = storeUser.payout || true
const userCountry = storeUser.locale ? storeUser.locale.split('-')[1] : ''

onMounted(() => {
  events.$on('template', (obj: { header: boolean; headerBlank: boolean; footer: boolean; footerBlank: boolean }) => {
    if (Object.prototype.hasOwnProperty.call(obj, 'footer')) {
      footerRef.value = obj.footer
    }
    if (Object.prototype.hasOwnProperty.call(obj, 'footerBlank')) {
      footerBlankRef.value = obj.footerBlank
    }
  })
})

function footerLink(name: string) {
  let url
  switch (name) {
    case 'home':
      url = '/gd/homepage/home.xhtml'
      break
    case 'impressum':
      url = '/gd/help/help.xhtml?page=help.impressum'
      break
    case 'contact':
      url = '/gd/support/contact.xhtml'
      break
    case 'about':
      url = 'https://inside.gameduell.com/#about'
      ;(window as any).open(url, '_blank', 'noopener')
      return
    case 'sitemap':
      url = '/gd/sitemap/index.xhtml'
      break
    case 'agb':
      url = '/gd/help/agb.xhtml'
      break
    case 'withdrawal':
      url = '/gd/help/withdrawal.xhtml'
      break
    case 'privacy':
      url = '/gd/help/privacy.xhtml'
      break
    case 'partner':
      url = '/gd/help/help.xhtml?page=help.partner'
      break
    case 'jobs':
      url = 'https://inside.gameduell.com/#jobs'
      ;(window as any).open(url, '_blank', 'noopener')
      return
    case 'mobile':
      url = '/gd/mobile/uiswitch/?desktop=false'
      break
    case 'accessibility':
      url = '/gd/help/accessibility.xhtml'
      break
  }
  location.href = url || '#'
}
function languageSelect(lang: string) {
  let l = ''
  // map languages to classic footer
  switch (lang) {
    case 'en':
      l = 'en_US'
      break
    case 'en-GB':
      l = 'en_GB'
      break
    case 'es':
      l = 'es_ES'
      break
    case 'es-US':
      l = 'es_US'
      break
    case 'fr':
      l = 'fr_FR'
      break
    case 'nl':
      l = 'nl_NL'
      break
    case 'sv':
      l = 'sv_SE'
      break
    case 'da':
      l = 'da_DK'
      break
    case 'de':
      l = 'de_DE'
      break
    case 'de-AT':
      l = 'de_AT'
      break
  }
  location.href = '/gd/switchLanguage?lang=' + l
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    duration: { enter: 0, leave: 500 }
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(GdFooter), {
        show: footerRef.value,
        class: "gd-footer",
        "user-country": _unref(userCountry),
        "payout-user": _unref(payout),
        blank: footerBlankRef.value,
        locales: _unref(storeGd).supportedLocales,
        onFlag: languageSelect,
        onLink: footerLink
      }, null, 8, ["show", "user-country", "payout-user", "blank", "locales"])
    ]),
    _: 1
  }))
}
}

})